import {getUserProperty} from "./userProfile";

const postLogin = () => {
    const loginFormElement = document.querySelector('#foPostLoginForm');
    const returnContextField = loginFormElement.returnContext;
    try {
        const locationObject = window.location;
        const accountId = getUserProperty('accountId');
        let search = locationObject.search;
        if (accountId) {
            search = search.match(/(\?|&)ACCOUNTID=/) ?
                search.replace(/ACCOUNTID=[0-9]*/, `ACCOUNTID=${accountId}`) :
                search + (search ? '&' : '?') + `ACCOUNTID=${accountId}`;
            returnContextField.value = locationObject.pathname + search + locationObject.hash;
        } else {
            returnContextField.value = locationObject.href.replace(locationObject.origin, '');
        }

        loginFormElement.submit();
    } catch (e) {
        window && window.console && window.console.log(e);
    }
};

const postLogout = (value) => {
    const logoutFormElement = document.querySelector('#foPostLogoutForm');
    const returnContextField = logoutFormElement.returnContext;
    const csrfField = logoutFormElement['X-XSRF-TOKEN'];
    const csrfToken = _getCookie('XSRF-TOKEN');
    try {
        returnContextField.value = value ? value : window.location.href.replace(window.location.origin, '');
        csrfField.value = csrfToken
        logoutFormElement.submit();
    } catch (e) {
        window && window.console && window.console.log(e);
    }
};

const _getCookie = (key) => {
    const value = document.cookie;
    let cookieValue;
    if (value) {
        const cookieRegex = RegExp(key + '=([\\w,\\-\\_]*);?', 'i');
        cookieValue = value.match(cookieRegex);
    }
    return (cookieValue && cookieValue[1]) || '';
}

export {postLogin, postLogout}


// WEBPACK FOOTER //
// ./src/app/utils/postLoginLogout.js